"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StayPropertyDetailResponseSchema = exports.StayPropertyDetailQuerySchema = exports.StayPropertyDetailInputSchema = void 0;
var zod_1 = require("zod");
/** BFF GET /stay-site/properties/:propertyId/detail path param */
exports.StayPropertyDetailInputSchema = zod_1.z.object({
    propertyId: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
});
/**
 * BFF GET /stay-site/properties/:propertyId/detail query params
 * @see specs/stay-api/detail-properties.md
 */
exports.StayPropertyDetailQuerySchema = zod_1.z.object({
    checkInDate: zod_1.z.string(),
    checkOutDate: zod_1.z.string(),
    adultPax: zod_1.z.coerce.number().int().min(1).max(30),
    childrenAges: zod_1.z
        .union([
        zod_1.z.array(zod_1.z.coerce.number().int()),
        zod_1.z.string().transform(function (s) { return (s ? s.split(',').map(function (n) { return parseInt(n, 10); }) : []); }),
    ])
        .optional(),
    baseDate: zod_1.z.string().optional(),
    baseTime: zod_1.z.string().optional(), // HH:mm, 야놀자타임 테스트 용도
});
/** BFF GET /stay-site/properties/:propertyId/detail 응답 (클라이언트 노출용, 명세 상 Response Body 구조) */
exports.StayPropertyDetailResponseSchema = zod_1.z
    .object({
    atf: zod_1.z.record(zod_1.z.unknown()).optional(),
    sellerPhone: zod_1.z.string().optional(),
    braze: zod_1.z.record(zod_1.z.unknown()).optional(),
    badges: zod_1.z.array(zod_1.z.unknown()).optional(),
    review: zod_1.z.record(zod_1.z.unknown()).optional(),
    banners: zod_1.z.array(zod_1.z.unknown()).optional(),
    event: zod_1.z.array(zod_1.z.unknown()).optional(),
    reservationSection: zod_1.z.unknown().optional(),
    locationSection: zod_1.z.unknown().optional(),
    facilitySection: zod_1.z.unknown().optional(),
    policySection: zod_1.z.unknown().optional(),
    overviewSection: zod_1.z.unknown().optional(),
    cancelPolicySection: zod_1.z.unknown().optional(),
    popularityMessage: zod_1.z.string().nullable(),
    calendar: zod_1.z.record(zod_1.z.unknown()).optional(),
    guests: zod_1.z.record(zod_1.z.unknown()).optional(),
    roomTypeInfo: zod_1.z.record(zod_1.z.unknown()).optional(),
    roomTypes: zod_1.z.array(zod_1.z.unknown()).optional(),
    gallery: zod_1.z.record(zod_1.z.unknown()).optional(),
    dmTalk: zod_1.z.boolean().optional(),
    googleStructuredData: zod_1.z.unknown().optional(),
    loginRecommendation: zod_1.z.array(zod_1.z.unknown()).optional(),
    expMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
    expMetas: zod_1.z.array(zod_1.z.unknown()).optional(),
})
    .passthrough();
